/* eslint-disable react/jsx-props-no-spreading */
import { SearchBar } from '@coop/cds-components';
import { type ComponentProps } from 'react';

export interface SearchProps extends ComponentProps<typeof SearchBar> {
    onEscapePress?: () => void;
    onEnterPress?: () => void;
}

const Search = (props: SearchProps) => {
    const handleKeyDown: SearchProps['onKeyDown'] = (e) => {
        if (e.key === 'Escape' && props.onEscapePress) {
            props.onEscapePress();
        } else if (e.key === 'Enter' && props.onEnterPress) {
            props.onEnterPress();
        } else {
            props.onKeyDown?.(e);
        }
    };

    return <SearchBar data-testid="search-input" {...props} onKeyDown={handleKeyDown} />;
};

export default Search;
